import { render, staticRenderFns } from "./WarehouseConfigDetailGeneralInfoContainer.vue?vue&type=template&id=1fbaa802&"
import script from "./WarehouseConfigDetailGeneralInfoContainer.vue?vue&type=script&lang=js&"
export * from "./WarehouseConfigDetailGeneralInfoContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports